import { render, staticRenderFns } from "./GestioneAttivitaProgettiEditComponent.vue?vue&type=template&id=03f9bd5d"
import script from "./GestioneAttivitaProgettiEditComponent.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaProgettiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports